module.exports = __webpack_public_path__ + "img/CY.853b4e1f.svg";